const types = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
  'light',
  'dark',
]

export default {
  state: {
    toasts: [],
  },
  getters: {
    allToasts: state => state.toasts,
  },
  mutations: {
    addToast(state, toast) {
      state.toasts.push(toast)
    },
    clearToast(state, toast) {
      const index = state.toasts.indexOf(toast)
      if (index >= 0) {
        state.toasts.splice(index, 1)
      }
      clearTimeout(toast.clearTimer)
    },
  },
  actions: {
    addToast({ commit }, { title, message, type }) {
      if (types.indexOf(type) === -1) {
        throw new Error(`toast type [${type}] not allowed.`)
      }
      const toast = {
        title,
        message,
        type,
        creationTimestamp: +new Date(),
        clearTimer: setTimeout(() => commit('clearToast', toast), 6000),
      }
      commit('addToast', toast)
    },
  },
}
